/* eslint-disable react/no-array-index-key */
import clsx from 'clsx';
import React from 'react';
import styles from './Spring.module.scss';
export const Spring = ({ easter = false }) => (<div className={styles.spring}>
    <span className={styles.springGrass}/>
    {[...new Array(40)].map((_, idx) => {
        const hasRight = Math.round(Math.random());
        const hasLeft = Math.round(Math.random());
        const daffodil = {
            position: 25 + Math.floor(Math.random() * 73),
            phonePosition: Math.floor(Math.random() * 15) + 1,
            animation: Math.floor(Math.random() * 15) + 1,
            transform: Math.floor(Math.random() * 15) + 1,
        };
        const multiDeviceClassName = idx < 15
            ? `phone-${daffodil.phonePosition}`
            : idx < 30
                ? `tablet-${daffodil.phonePosition}`
                : 'desktop';
        const hasEgg = easter ? Math.floor(Math.random() * 3) : -1;
        const egg = {
            position: hasEgg === 0 ? Math.floor(Math.random() * 98) : 0,
            rotation: hasEgg === 0 ? Math.floor(Math.random() * 10) : 0,
            type: hasEgg === 0 ? Math.floor(Math.random() * 5) + 1 : 1,
            delay: hasEgg === 0 ? Math.floor(Math.random() * 10) : 1,
        };
        return (<div className={styles.springItem} key={`${idx}-spring-item`}>
          {hasEgg === 0 && (<div key={`${idx}-easter-egg`} className={clsx(styles.easterEgg, styles[`rotation-${egg.rotation}`], styles[`type-${egg.type}`], styles[`delay-${egg.delay}`])} style={{ left: `${egg.position}%` }}>
              <span />
            </div>)}
          {hasLeft === 1 && (<div key={`${idx}-daffodil-reflected`} className={clsx(styles.springDaffodil, styles.reflected, styles[`animation-${daffodil.animation}`], styles[`transform-${daffodil.transform}`], styles[multiDeviceClassName])} style={{ left: `${daffodil.position}%` }}>
              <span className={styles.daffodilStem}/>
              <span className={styles.daffodilFlower}/>
            </div>)}
          {hasRight === 1 && (<div key={`${idx}-daffodil`} className={clsx(styles.springDaffodil, styles[`animation-${daffodil.animation}`], styles[`transform-${daffodil.transform}`], styles[multiDeviceClassName])} style={{ left: `${daffodil.position}%` }}>
              <span className={styles.daffodilStem}/>
              <span className={styles.daffodilFlower}/>
            </div>)}
        </div>);
    })}
  </div>);
